import axios from 'axios';

let tenantIdentityServiceUrl = process.env.REACT_APP_TENANT_IDENTITY_SERVICE_URL;

const getPoolInformation = async (tenantGuid) => {
    try {
        let apiURL = `${tenantIdentityServiceUrl}/tenantIdentity/getTenantByGuid/${tenantGuid}`;

        return new Promise((resolve, reject) => {
            axios.get(apiURL).then((response) => {
                resolve(response.data.dataObject[0]);
            }).catch((err) => {
                console.log('getPoolInformation err', err);
                reject(err);
            });
        });
    } catch (error) {
        console.log('getPoolInformation error', error);
    }
}

const getTenantLanguages = async (tenantGuid) => {
    try {
        let apiURL = `${tenantIdentityServiceUrl}/tenantIdentity/getTenantLanguage/${tenantGuid}`;

        return new Promise((resolve, reject) => {
            axios.get(apiURL).then((response) => {
                resolve(response.data.dataObject);
            }).catch((err) => {
                console.log('getTenantLanguages err', err);
                reject(err);
            });
        });
    } catch (error) {
        console.log('getTenantLanguages error', error);
    }
}

const addTenantLanguage = async (inputData) => {
    try {
        let apiURL = `${tenantIdentityServiceUrl}/tenantIdentity/addTenantLanguage`;

        return new Promise((resolve, reject) => {
            axios.post(apiURL, inputData).then((response) => {
                resolve(response);
            }).catch((err) => {
                console.log('addTenantLanguage err', err);
                reject(err);
            });
        });
    } catch (error) {
        console.log('addTenantLanguage error', error);
    }
}

const createNewUserPoolForTenantAfterPurchase = async (inputData) => {
    try {
        let apiURL = `${tenantIdentityServiceUrl}/tenantIdentity/createNewUserPoolForTenantAfterPurchase`;

        return new Promise((resolve, reject) => {
            axios.post(apiURL, inputData).then((response) => {
                resolve(response);
            }).catch((err) => {
                console.log('createNewUserPoolForTenantAfterPurchase err', err);
                reject(err);
            });
        });
    } catch (error) {
        console.log('createNewUserPoolForTenantAfterPurchase error', error);
    }
}

const updateTenant = async (updateData) => {
    try {
        let apiURL = `${tenantIdentityServiceUrl}/tenantIdentity/updateTenant`;

        return new Promise((resolve, reject) => {
            axios.put(apiURL, updateData).then((response) => {
                resolve(response);
            }).catch((err) => {
                console.log('updateTenant err', err);
                reject(err);
            });
        });
    } catch (error) {
        console.log('updateTenant error', error);
    }
}

const deleteTenantLanguage = async (languageGuid, tenantGuid) => {
    try {
        let apiURL = `${tenantIdentityServiceUrl}/tenantIdentity/deleteTenantLanguage`;

        return new Promise((resolve, reject) => {
            axios.delete(apiURL, {
                params: {
                    languageGuid: languageGuid,
                    tenantGuid: tenantGuid
                }
            }).then((response) => {
                resolve(response.data.dataObject);
            }).catch((err) => {
                console.log('deleteTenantLanguage err', err);
                reject(err);
            });
        });
    } catch (error) {
        console.log('deleteTenantLanguage error', error);
    }
}

const insertIntoHistoryTbl = async (inputData) => {
    try {
        let apiURL = `${tenantIdentityServiceUrl}/tenantIdentity/insertIntoHistoryTbl`;

        return new Promise((resolve, reject) => {
            axios.post(apiURL, inputData).then((response) => {
                resolve(response.data.dataObject);
            }).catch((err) => {
                console.log('insertIntoHistoryTbl err', err);
                reject(err);
            });
        });
    } catch (error) {
        console.log('insertIntoHistoryTbl error', error);
    }
}

const getUserDetails = async (email) => {
    try {
        let apiURL = `${tenantIdentityServiceUrl}/tenantIdentity/getUserDetailsByEmailId?emailId=${email}`;

        return new Promise((resolve, reject) => {
            axios.get(apiURL).then((response) => {
                resolve(response.data.dataObject);
            }).catch((err) => {
                console.log('getTenantPackage err', err);
                reject(err);
            });
        });
    } catch (error) {
        console.log('getUserDetails error', error);
    }
}

const getTenantPackage = async (tenantGuid) => {
    try {
        let apiURL = `${tenantIdentityServiceUrl}/tenantIdentity/getAllPackageByGuid/${tenantGuid}`;

        return new Promise((resolve, reject) => {
            axios.get(apiURL).then((response) => {
                resolve(response.data.dataObject);
            }).catch((err) => {
                console.log('getTenantPackage err', err);
                reject(err);
            });
        });
    } catch (error) {
        console.log('getTier error', error);
    }
}

const getTenantTier = async () => {
    try {
        let apiURL = `${tenantIdentityServiceUrl}/tenantIdentity/tier`;

        return new Promise((resolve, reject) => {
            axios.get(apiURL).then((response) => {
                resolve(response.data.dataObject);
            }).catch((err) => {
                console.log('getTenantTier err', err);
                reject(err);
            });
        });
    } catch (error) {
        console.log('getTenantTier error', error);
    }
}

const getTenantProduct = async () => {
    try {
        let apiURL = `${tenantIdentityServiceUrl}/tenantIdentity/product`;
        
        return new Promise((resolve, reject) => {
            axios.get(apiURL).then((response) => {
                resolve(response.data.dataObject);
            }).catch((err) => {
                console.log('getTenantProduct err', err);
                reject(err);
            });
        });
    } catch (error) {
        console.log('getTenantProduct error', error);
    }
}

const deleteTenantPackage = async (packageGuid) => {
    try {
        let apiURL = `${tenantIdentityServiceUrl}/tenantIdentity/package/${packageGuid}`;
        return new Promise((resolve, reject) => {
            axios.delete(apiURL).then((response) => {
                resolve(response);
            }).catch((err) => {
                console.log('deleteTenantPackage err', err);
                reject(err);
            });
        });
    } catch (error) {
        console.log('deleteTenantPackage error', error);
    }
}

const addTenantPackage = async (inputArr) => {
    try {
        let apiURL = `${tenantIdentityServiceUrl}/tenantIdentity/package`;

        return new Promise((resolve, reject) => {
            axios.post(apiURL, inputArr).then((response) => {
                resolve(response);
            }).catch((err) => {
                console.log('addTenantPackage err', err);
                reject(err);
            });
        });

    } catch (error) {
        console.log('addTenantPackage error', error);
    }
}


export {
    getPoolInformation,
    getUserDetails,
    getTenantLanguages,
    addTenantLanguage,
    updateTenant,
    insertIntoHistoryTbl,
    deleteTenantLanguage,
    getTenantPackage,
    getTenantTier,
    getTenantProduct,
    deleteTenantPackage,
    addTenantPackage,
    createNewUserPoolForTenantAfterPurchase
}